import { FC } from 'react'
import styles from './styles.module.scss'
import { Link } from '@/components/Link'
import { Button } from '@/components/Button'
import YAMLData from '../../../content/onboardingConsentDetails.yaml'

interface MarketingConsentProps {
  onSubmit: () => void
}

const parseConsentText = (text: string) => {
  const normalized = text.replace(/\r\n/g, '\n').trim()
  const lines = normalized.split('\n').filter(Boolean)
  const ANCHOR_REGEX = /(<a[^>]*>[\s\S]*?<\/a>)/gi
  return lines.map((line, lineIdx) => {
    const segments = line.split(ANCHOR_REGEX).filter(s => s.length > 0)
    const children = segments.map((seg, segIdx) => {
      if (/^<a[^>]*>[\s\S]*?<\/a>$/.test(seg)) {
        const hrefMatch = seg.match(/href=["']([^"']+)["']/i)
        const labelMatch = seg.match(/<a[^>]*>([\s\S]*?)<\/a>/i)
        const href = hrefMatch?.[1] || ''
        const label = (labelMatch?.[1] || href).trim()
        return (
          <Link key={segIdx} newTab url={href}>
            {label}
          </Link>
        )
      }
      return <span key={`t-${lineIdx}-${segIdx}`}>{seg}</span>
    })
    return <p key={lineIdx}>{children}</p>
  })
}

export const MarketingConsent: FC<MarketingConsentProps> = ({ onSubmit }) => {
  return (
    <div className={styles.container}>
      <h3>{YAMLData.consentName}</h3>
      {parseConsentText(YAMLData.consentText)}
      <div className={styles.buttonContainer}>
        <Button className={styles.sendButton} onClick={() => onSubmit()}>
          Continue
        </Button>
      </div>
    </div>
  )
}
